import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  TextField,
  Paper,
  Typography,
  Grid,
  Switch,
  Divider,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  CardMedia,
  Box,
  LinearProgress
} from '@material-ui/core';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import storage from "../../../../firebaseConfig.js"
import Autocomplete from '@material-ui/lab/Autocomplete';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { NetworkContext } from '../../../../context/NetworkContext.js';

const AD_TYPES = ['banner', 'listing', 'detail'];
const MODULES = ['live', 'rate', 'news', 'spot', 'future', 'homepage'];
const SCHEDULE_MODES = [
  { value: 'all_time', label: 'All time' },
  { value: 'period', label: 'Period' }
];

function toDatetimeLocal(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
    marginTop: theme.spacing(2),
    textAlign: 'left'
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  section: {
    marginBottom: theme.spacing(3)
  },
  sectionTitle: {
    marginBottom: theme.spacing(1.5),
    fontWeight: 600
  },
  input: {
    display: 'none',
  },
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  },
  switchRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  creativePreviewCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
  },
  creativeMedia: {
    height: 200,
    backgroundSize: 'contain',
    backgroundColor: theme.palette.grey[100],
    cursor: 'pointer',
  },
  emptyUpload: {
    minHeight: 200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  uploadIcon: {
    fontSize: 40,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  progressWrap: {
    padding: theme.spacing(0, 2, 1),
  },
  cardActions: {
    justifyContent: 'flex-end',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
}));

const BrokerDetails = props => {
  const { open, onClose, onUpdate, usercontent, masters, viewtype, className, isEdit, ...rest } = props;

  const classes = useStyles();
  const [subcommodity, setSubcommodity] = React.useState([]);
  const [error, setError] = React.useState({});
  const [previewOpen, setPreviewOpen] = React.useState(false);
  const fileInputRef = React.useRef(null);

  const initialValues = {
    languages: ['All', 'Tamil', 'English', 'Telugu'],
    brokers_name: '',
    contact_number: '',
    city: '',
    image: '',
    adsurl: '',
    module: '',
    imageurl: '',
    commodity: null,
    subcommodity: null,
    priority: '',
    adtype: '',
    language: [],
    state: {},
    status: true,
    schedule_mode: 'all_time',
    start_at: '',
    end_at: '',
    timer_enabled: false,
    timer_seconds: ''
  };
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [percent, setPercent] = React.useState(0);

  const [values, setValues] = useState({
    ...initialValues
  });

  const isBanner = values.adtype === 'banner';

  const setData = async (value, name) => {
    if (name === "image") {
      if (!value) {
        alert("Please choose a file first!")
        return;
      }

      const storageRef = ref(storage, `/spot/${value.name}`)
      const uploadTask = uploadBytesResumable(storageRef, value);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setPercent(percent);
        },
        (err) => console.log(err),
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setValues(values => ({
              ...values,
              imageurl: url
            }));
            setPercent(0);
          });
        }
      );
    }
  }

  React.useEffect(() => {
    if (!usercontent || Object.keys(usercontent).length === 0) {
      return;
    }
    const next = {
      ...initialValues,
      ...usercontent,
      schedule_mode: usercontent.schedule_mode || 'all_time',
      start_at: toDatetimeLocal(usercontent.start_at),
      end_at: toDatetimeLocal(usercontent.end_at),
      timer_enabled: !!usercontent.timer_enabled,
      timer_seconds: usercontent.timer_seconds != null ? usercontent.timer_seconds : '',
      status: usercontent.status != null ? usercontent.status : true,
    };
    setValues(next);
    if (usercontent.commodity && usercontent.commodity.id) {
      fetchsubcommodity([usercontent.commodity.id]);
    }
  }, [usercontent]);

  const handleSubmit = event => {
    event.preventDefault();
    let errorobj = {}
    let isvalid = true;

    if (!values.adtype) {
      isvalid = false
      errorobj['adtype'] = "Please choose ad type"
    }
    if (!values.module) {
      isvalid = false
      errorobj['module'] = "Please choose module"
    }
    if (!values.commodity || !values.commodity.id) {
      isvalid = false
      errorobj['commodity'] = "Please choose commodity"
    }
    if (!isBanner && (!values.subcommodity || !values.subcommodity.id)) {
      // sub optional historically for listing/detail — keep optional to avoid breaking edits
    }
    if (!values.state || !values.state.name) {
      isvalid = false
      errorobj['state'] = "Please choose state"
    }
    if (values.priority === '' || values.priority === null || values.priority === undefined) {
      isvalid = false
      errorobj['priority'] = "Please enter priority"
    }
    if (!values.imageurl || String(values.imageurl).trim().length === 0) {
      isvalid = false
      errorobj['imageurl'] = "Please upload or enter image"
    }
    if ((values.schedule_mode || 'all_time') === 'period') {
      if (!values.start_at || !values.end_at) {
        isvalid = false
        errorobj['schedule'] = "Period start and end are required"
      } else if (new Date(values.start_at) > new Date(values.end_at)) {
        isvalid = false
        errorobj['schedule'] = "Period start must be before end"
      }
    }
    if (isBanner && values.timer_enabled) {
      const secs = parseInt(values.timer_seconds, 10);
      if (!secs || secs < 1) {
        isvalid = false
        errorobj['timer_seconds'] = "Timer seconds must be at least 1"
      }
    }
    setError({ ...errorobj })

    if (isvalid) {
      const timerSecondsNum = parseInt(values.timer_seconds, 10);
      const timerOn = isBanner && !!values.timer_enabled && timerSecondsNum >= 1;
      const payload = {
        ...values,
        schedule_mode: values.schedule_mode || 'all_time',
        start_at: (values.schedule_mode || 'all_time') === 'period' && values.start_at
          ? new Date(values.start_at).toISOString()
          : null,
        end_at: (values.schedule_mode || 'all_time') === 'period' && values.end_at
          ? new Date(values.end_at).toISOString()
          : null,
        timer_enabled: timerOn,
        timer_seconds: timerOn ? timerSecondsNum : null,
        subcommodity: isBanner ? null : values.subcommodity,
      };
      onUpdate && onUpdate(payload);
    }
  };

  const handleoptionchange = type => (event, value) => {
    if (type === 'commodity') {
      if (value) {
        fetchsubcommodity([value.id])
      } else {
        setSubcommodity([])
      }
      setValues(prev => ({
        ...prev,
        commodity: value,
        subcommodity: null
      }));
      return;
    }

    if (type === 'adtype') {
      setValues(prev => ({
        ...prev,
        adtype: value,
        subcommodity: value === 'banner' ? null : prev.subcommodity,
        timer_enabled: value === 'banner' ? prev.timer_enabled : false,
        timer_seconds: value === 'banner' ? prev.timer_seconds : ''
      }));
      return;
    }

    if (type === 'schedule_mode') {
      const mode = value && value.value ? value.value : (value || 'all_time');
      setValues(prev => ({
        ...prev,
        schedule_mode: mode,
        start_at: mode === 'period' ? prev.start_at : '',
        end_at: mode === 'period' ? prev.end_at : ''
      }));
      return;
    }

    if (type === 'state') {
      setValues(prev => ({
        ...prev,
        state: value,
        city: ''
      }));
      return;
    }

    if (type === 'status' || type === 'timer_enabled') {
      const checked = typeof value === 'boolean' ? value : !!(event && event.target && event.target.checked);
      setValues(prev => ({
        ...prev,
        [type]: checked
      }));
      return;
    }

    setValues(prev => ({
      ...prev,
      [type]: value
    }));
  }

  const handleinputchange = type => e => {
    const value = e.target.value;
    setValues(prev => ({
      ...prev,
      [type]: value
    }));
  }

  async function fetchsubcommodity(commodityID) {
    let bodycontent = {
      commodity: commodityID
    }
    let commodity_arr = await sendNetworkRequest('/admin/getsubcommodityforcommodity', {}, bodycontent, false)
    setSubcommodity(commodity_arr.module || [])
  }

  const scheduleModeValue = SCHEDULE_MODES.find(
    m => m.value === (values.schedule_mode || 'all_time')
  ) || SCHEDULE_MODES[0];

  return (
    <Paper className={classes.papercontent}>
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >
        <div className={classes.content}>
          <input
            accept="image/*"
            className={classes.input}
            id="icon-button-file"
            ref={fileInputRef}
            type="file"
            onChange={e => {
              const file = e.target.files && e.target.files[0];
              if (file) {
                setData(file, "image");
              }
              e.target.value = '';
            }}
          />
          {previewOpen && values.imageurl && (
            <Lightbox
              mainSrc={values.imageurl}
              onCloseRequest={() => setPreviewOpen(false)}
            />
          )}
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div className={classes.section}>
                <Typography className={classes.sectionTitle} variant="h6">1. Ad type</Typography>
                <Autocomplete
                  options={AD_TYPES}
                  value={values.adtype || null}
                  disabled={viewtype == 2}
                  onChange={handleoptionchange('adtype')}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Ad Type"
                      error={!!error.adtype}
                      helperText={error.adtype}
                      fullWidth
                      margin="dense"
                      variant="outlined"
                    />
                  )}
                />
              </div>

              <Divider />

              <div className={classes.section} style={{ marginTop: 24 }}>
                <Typography className={classes.sectionTitle} variant="h6">2. Placement</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={MODULES}
                      value={values.module || null}
                      disabled={viewtype == 2}
                      onChange={handleoptionchange('module')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Module"
                          error={!!error.module}
                          helperText={error.module}
                          fullWidth
                          margin="dense"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={masters.commodity || []}
                      value={values.commodity || null}
                      disabled={viewtype == 2}
                      onChange={handleoptionchange('commodity')}
                      getOptionLabel={(option) => option?.name || ''}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Commodity"
                          error={!!error.commodity}
                          helperText={error.commodity}
                          fullWidth
                          margin="dense"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                  {!isBanner && (
                    <Grid item xs={12} sm={6}>
                      <Autocomplete
                        options={subcommodity}
                        getOptionLabel={(option) => option?.name || ''}
                        value={values.subcommodity || null}
                        disabled={viewtype == 2}
                        onChange={handleoptionchange('subcommodity')}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Sub Commodity"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid>
                  )}
                </Grid>
              </div>

              <Divider />

              <div className={classes.section} style={{ marginTop: 24 }}>
                <Typography className={classes.sectionTitle} variant="h6">3. Creative</Typography>
                <Grid container spacing={3} alignItems="stretch">
                  <Grid item xs={12} md={7}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      autoComplete="off"
                      onChange={handleinputchange('adsurl')}
                      value={values.adsurl || ''}
                      label="Ads URL"
                      helperText="Destination URL when the ad is tapped"
                    />
                    <Box mt={2}>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        autoComplete="off"
                        onChange={handleinputchange('imageurl')}
                        value={values.imageurl || ''}
                        error={!!error.imageurl}
                        helperText={error.imageurl || 'Paste a URL or upload an image on the right'}
                        label="Image URL"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <Card className={classes.creativePreviewCard}>
                      <CardHeader
                        title="Ad image"
                        titleTypographyProps={{ variant: 'subtitle1' }}
                        subheader={values.imageurl ? 'Click image to enlarge' : 'Required'}
                        subheaderTypographyProps={{ variant: 'caption' }}
                      />
                      {values.imageurl ? (
                        <CardMedia
                          className={classes.creativeMedia}
                          image={values.imageurl}
                          title="Ad preview"
                          onClick={() => setPreviewOpen(true)}
                        />
                      ) : (
                        <CardContent className={classes.emptyUpload}>
                          <CloudUploadOutlinedIcon className={classes.uploadIcon} />
                          <Typography variant="body2" color="textSecondary" gutterBottom>
                            No image yet
                          </Typography>
                          <Button
                            color="primary"
                            variant="contained"
                            size="small"
                            onClick={() => fileInputRef.current && fileInputRef.current.click()}
                            disabled={viewtype == 2}
                          >
                            <CloudUploadOutlinedIcon fontSize="small" className={classes.buttonIcon} />
                            Upload image
                          </Button>
                        </CardContent>
                      )}
                      {percent > 0 && percent < 100 && (
                        <div className={classes.progressWrap}>
                          <Typography variant="caption" color="textSecondary">
                            Uploading {percent}%
                          </Typography>
                          <LinearProgress variant="determinate" value={percent} color="primary" />
                        </div>
                      )}
                      {values.imageurl && (
                        <CardActions className={classes.cardActions} disableSpacing>
                          <Button
                            size="small"
                            color="primary"
                            onClick={() => setPreviewOpen(true)}
                          >
                            <ImageOutlinedIcon fontSize="small" className={classes.buttonIcon} />
                            View
                          </Button>
                          <Button
                            size="small"
                            color="primary"
                            variant="outlined"
                            onClick={() => fileInputRef.current && fileInputRef.current.click()}
                            disabled={viewtype == 2}
                          >
                            Reupload
                          </Button>
                        </CardActions>
                      )}
                    </Card>
                  </Grid>
                </Grid>
              </div>

              <Divider />

              <div className={classes.section} style={{ marginTop: 24 }}>
                <Typography className={classes.sectionTitle} variant="h6">4. Priority & status</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      autoComplete="off"
                      onChange={handleinputchange('priority')}
                      error={!!error.priority}
                      helperText={error.priority}
                      value={values.priority}
                      label="Priority"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    {masters.state && (
                      <Autocomplete
                        options={masters.state || []}
                        getOptionLabel={(option) => option?.name || ''}
                        value={values.state || null}
                        disabled={viewtype == 2}
                        onChange={handleoptionchange('state')}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="State"
                            error={!!error.state}
                            helperText={error.state}
                            fullWidth
                            margin="dense"
                            variant="outlined"
                          />
                        )}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={4} className={classes.switchRow}>
                    <Typography variant="body1">Active</Typography>
                    <Switch
                      checked={!!values.status}
                      color="secondary"
                      edge="start"
                      name="Status"
                      onChange={handleoptionchange('status')}
                    />
                  </Grid>
                </Grid>
              </div>

              <Divider />

              <div className={classes.section} style={{ marginTop: 24 }}>
                <Typography className={classes.sectionTitle} variant="h6">5. Schedule</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Autocomplete
                      options={SCHEDULE_MODES}
                      value={scheduleModeValue}
                      getOptionLabel={(option) => option.label}
                      onChange={handleoptionchange('schedule_mode')}
                      disableClearable
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Schedule"
                          error={!!error.schedule}
                          helperText={error.schedule}
                          fullWidth
                          margin="dense"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                  {(values.schedule_mode || 'all_time') === 'period' && (
                    <>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          type="datetime-local"
                          label="Start"
                          InputLabelProps={{ shrink: true }}
                          value={values.start_at || ''}
                          onChange={handleinputchange('start_at')}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          type="datetime-local"
                          label="End"
                          InputLabelProps={{ shrink: true }}
                          value={values.end_at || ''}
                          onChange={handleinputchange('end_at')}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </div>

              {isBanner && (
                <>
                  <Divider />
                  <div className={classes.section} style={{ marginTop: 24 }}>
                    <Typography className={classes.sectionTitle} variant="h6">6. Banner timer</Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={4} className={classes.switchRow}>
                        <Typography variant="body1">Skip timer</Typography>
                        <Switch
                          checked={!!values.timer_enabled}
                          color="secondary"
                          edge="start"
                          name="timer_enabled"
                          onChange={(e) => {
                            const checked = !!(e && e.target && e.target.checked);
                            setValues(prev => ({
                              ...prev,
                              timer_enabled: checked,
                              timer_seconds: checked ? prev.timer_seconds : ''
                            }));
                          }}
                        />
                      </Grid>
                      {!!values.timer_enabled && (
                        <Grid item xs={12} sm={4}>
                          <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            type="number"
                            inputProps={{ min: 1 }}
                            onChange={handleinputchange('timer_seconds')}
                            error={!!error.timer_seconds}
                            helperText={error.timer_seconds || 'Seconds before close/skip is allowed'}
                            value={values.timer_seconds}
                            label="Skip after (seconds)"
                          />
                        </Grid>
                      )}
                    </Grid>
                  </div>
                </>
              )}
            </Grid>
          </Grid>
        </div>
        <div className={classes.actions}>
          <Button
            color="primary"
            type="submit"
            variant="contained"
          >
            {isEdit ? "Update" : "Submit"}
          </Button>
        </div>
      </form>
    </Paper>
  );
};

BrokerDetails.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onUpdate: PropTypes.func,
  open: PropTypes.bool,
  masters: PropTypes.object
};

export default BrokerDetails;
